import { Directive, HostListener, Input } from '@angular/core';

/*
  If limits input to 4 digits
  Typing 12345 will be trimmed to 1234 because limit set to 4.
*/

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[numberMaxLength]',
})
export class NumberMaxLengthDirective {
  // Take the numberMaxLength as input
  @Input('numberMaxLength') maxLength: number;

  // Listen to every input event
  @HostListener('input', ['$event.target'])
  onInput(input: HTMLInputElement): void {
    const max = this.maxLength;

    // If maxLength is null, remove maxlength attribute (no limit)
    if (this.maxLength === null) {
      input?.removeAttribute('maxlength');
      return;
    }

    // If input is longer than allowed
    if (input.value && input.value.length > max) {
      const trimmedValue = input.value.slice(0, max); // limit to maxLength

      if (input.value !== trimmedValue) {
        input.value = trimmedValue;

        // Force Angular change detection
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }
}
